import styled from "@emotion/styled";
import { useCalendarContext } from "../../../contexts/Calendar";

import { BasicFlex } from "../../../utils/Common";

const timeFormatter = new Intl.DateTimeFormat('en-US', { 
  hour: 'numeric', 
  hour12: true 
});

const DEFAULT_DIVISIONS = 2;

// 0 or 1 = no breaks (hours only). Missing/invalid = default.
const parseDivisions = (value) => {
  if (value === null || value === undefined || value === '') return DEFAULT_DIVISIONS;
  const num = Number(value);
  if (Number.isNaN(num)) return DEFAULT_DIVISIONS;
  return Math.max(1, Math.floor(num));
};

const TimelineHour = styled.div`
  text-transform: uppercase;
  color: ${props => props.theme.colors.mildText};
  font-size: 1.4rem;
  height: ${props => props.$height || '6rem'};
  text-align: center;
  font-weight: 600;

   @media ${props => props.theme.breaks.down('md')} {
     font-size: 1rem;
     color: inherit;
   }
`;

const HourPointContainer = styled(BasicFlex)`
  flex-direction: column;
  height: 92%;
  justify-content: space-around;
  /* padding-right: 1.5rem; */
  /* padding-top: .5rem; */
`

const HourPoints = styled.div`
  font-size: .9rem;
  font-weight: 400;
`

  const PrintTimelineHours = () => {
    const { setting } = useCalendarContext() || {};

    let { view_density, hourly_divisions, display_hours } = setting?.data || {};
    let rowHeightSetting = +view_density || 24;
    const rowHeight = rowHeightSetting + 'rem'; 

    let beginShow = +display_hours?.start ? +display_hours?.start : 0;
    let endShow = +display_hours?.end ? +display_hours?.end : 24;

    const divisions = parseDivisions(hourly_divisions);
    const showBreaks = divisions > 1;
    
    return Array.from({ length: 24 }, (_, i) => {
      const date = new Date(1970, 0, 1, i);

      if (i < beginShow || i >= endShow) return null;
      return (
        <TimelineHour $height={rowHeight} key={i}>
          {timeFormatter.format(date).toLowerCase()}
          {showBreaks && (
            <HourPointContainer dir="column" align="center" justify="space-between">
              {Array.from({ length: divisions - 1 }, (_, j) => j + 1).map((index) => {
                let minute = 60 / divisions * index;
                return (
                  <HourPoints key={index}>
                    {minute}
                  </HourPoints>
              )}
              )}
            </HourPointContainer>
          )}
        </TimelineHour>
      );
    });
  };

  export default PrintTimelineHours